export interface ILang {
	[key: string]: {
		text: string;
		lng: 'en' | 'de' | 'fr' | 'tr' | 'es' | 'it' | 'nl';
		icon: string;
	};
}

const LANG: ILang = {
	DE: {
		text: 'Deutsche',
		lng: 'de',
		icon: 'CustomGermany',
	},
	EN: {
		text: 'English',
		lng: 'en',
		icon: 'CustomUsa',
	},
	ES: {
		text: 'Español',
		lng: 'es',
		icon: 'CustomSpain',
	},
	FR: {
		text: 'Français',
		lng: 'fr',
		icon: 'CustomFrance',
	},
	IT: {
		text: 'Italiano',
		lng: 'it',
		icon: 'CustomItaly',
	},
	NL: {
		text: 'Nederlands',
		lng: 'nl',
		icon: 'CustomNetherlands',
	},
	TR: {
		text: 'Türkçe',
		lng: 'tr',
		icon: 'CustomTurkey',
	},
	
};

export const getLangWithKey = (key: ILang['key']['lng']): ILang['key'] => {
	// @ts-ignore
	return LANG[Object.keys(LANG).filter((f) => key.includes(LANG[f].lng))];
};

export default LANG;
